import { Component, OnInit } from '@angular/core';
import { chartTransition } from '../_animations/index';

@Component({
  selector: 'app-chart1',
  templateUrl: './chart1.component.html',
  animations: [chartTransition],
  host: { '[@chartTransition]': '' },
  styleUrls: ['./chart1.component.css']
})
export class Chart1Component implements OnInit {
  public mode: any;
  
  solvents = [
    {value: 'MeOH', viewValue: 'MeOH'},
    {value: 'CAN', viewValue: 'CAN'},
    {value: 'Mix', viewValue: 'Mix'}
  ];

  modes = [
    {value: 'Isocratic', viewValue: 'Isocratic'},
    {value: 'Gradient', viewValue: 'Gradient'}
  ];

  initials = [
    {value: 5, viewValue: 5 },
    {value: 30, viewValue: 30 }
  ];

  gradients = [
    {value: 5, viewValue: 5},
    {value: 10, viewValue: 10},
    {value: 15, viewValue: 15},
    {value: 20, viewValue: 20}
  ];

  pressures = [
    {value: 3500, viewValue: 3500},
    {value: 7500, viewValue: 7500}
  ];

  temperatures = [
    {value: "Ambient", viewValue: "Ambient"},
    {value: 40, viewValue: 40},
    {value: 50, viewValue: 50}
  ];

  phases = [
    {value: "C18", viewValue: "C18"},
    {value: "IDB", viewValue: "IDB"},
    {value: "PFPP", viewValue: "PFPP"},
    {value: "Phenyl", viewValue: "Phenyl"},
    {value: "C18 Aqueous", viewValue: "C18 Aqueous"}
  ];

  lengths = [
    {value: 50, viewValue: 50},
    {value: 100, viewValue: 100},
    {value: 150, viewValue: 150},
    {value: 250, viewValue: 250}
  ];

  diameters = [
    {value: 2.1, viewValue: 2.1},
    {value: 3.2, viewValue: 3.2},
    {value: 4.6, viewValue: 4.6}
  ];

  particles = [
    {value: 1.9, viewValue: 1.9},
    {value: 3, viewValue: 3},
    {value: 5, viewValue: 5},
    {value: "coreshell", viewValue: "coreshell"}
  ];

  carbons = [
    {value: 20, viewValue: 20},
    {value: 11, viewValue: 11},
    {value: "?", viewValue: "?"}
  ];

  pores = [
    {value: 100, viewValue: 100},
    {value: 140, viewValue: 140},
    {value: "?", viewValue: "?"}
  ];

  samples = [
    {value: 0.1, viewValue: 0.1},
    {value: 0.05, viewValue: 0.05}
  ];

  constructor() { }

  ngOnInit() {
  }

}
